import React from 'react';
import { PropTypes } from 'prop-types';
import styled, { css } from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { format } from '@origo_vl_banking/utils';
import StyledLabel from '../inputs/components/StyledLabel';

const LabelContainer = styled.div`
  margin-right: ${props => props.margin && '50px'};
  /* padding-left: 1em;
  padding-right: 1em; */

  ${props =>
    props.flex &&
    `@media (max-width: 470px) {
    display: flex;
    padding: 16px;
    flex-wrap: wrap;
    text-align: center;
  }`}
`;

const Label = styled(StyledLabel)`
  ${props =>
    props.flex &&
    `@media (max-width: 470px) {
    margin: auto;
    padding-right: 4px;
  }`}
`;

const Text = styled.div`
  width: 100%;
  margin-top: ${props => props.margin && '8px'};
  font-size: 22px;
  line-height: 25px;
  font-weight: bold;
  color: ${props => props.theme.iconColor};

  ${({ privateMode, theme }) => {
    if (privateMode) {
      return css`
        color: transparent;
        text-shadow: 0 0 25px rgba(0, 0, 0, 0.25);

        :hover {
          color: ${theme.iconColor};
          text-shadow: none;
        }
      `;
    }
    return '';
  }};

  @media (max-width: 470px) {
    margin: auto;
  }
`;

class HeadingLabel extends React.PureComponent {
  render() {
    const {
      heading, text, type, margin, flex, privateMode, suffix,
    } = this.props;

    return (
      <LabelContainer margin={margin} flex={flex}>
        <Label flex={flex}>
          <FormattedMessage id={heading} />
        </Label>
        <Text margin={margin} privateMode={privateMode}>
          {type === 'number' && format.decimal(text)}
          {type === 'text' && <FormattedMessage id={text} />}
          {type === 'currency' && `${format.decimal(text)} kr.`}
          {suffix && suffix}
        </Text>
      </LabelContainer>
    );
  }
}

HeadingLabel.propTypes = {
  heading: PropTypes.string,
  type: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  margin: PropTypes.bool,
  flex: PropTypes.bool,
  privateMode: PropTypes.bool,
  suffix: PropTypes.string,
};

HeadingLabel.defaultProps = {
  heading: 'Til ráðstöfunar',
  text: 'Missing',
  margin: true,
  flex: false,
  privateMode: false,
  suffix: null,
};

export default HeadingLabel;
